module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/casetype/casetype-grid/casetype-grid.component.css
// module id = ./src/app/master/casetype/casetype-grid/casetype-grid.component.css
// module chunks = main